import * as React from 'react';
import {
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { TaskDefinition } from 'gossamer-model';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const WorkflowSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({ where: { and: TaskDefinition.defaultFilters } });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(TaskDefinition, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(TaskDefinition, queryOptions);

  return (
    <Section>
      <PaginatorAndListSettings
        entity={TaskDefinition}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
